/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Shore Power Hub API
 * Shore Power Hub provides the backend services for Plug Insight. <br><br>The spec is available at \<this URL\>/swagger.json.
 * OpenAPI spec version: 2
 */
import { useCallback } from "react";
import {
  useQuery,
  type DataTag,
  type DefinedInitialDataOptions,
  type DefinedUseQueryResult,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UndefinedInitialDataOptions,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

import { useOrvalAxiosInstance, type ErrorType } from "../../useOrvalAxios";
import type {
  ApitypeAppError2,
  ApitypePermissionsResponse,
  ApitypeRolesResponse,
  ApitypeSystemEventResponse2,
  ApitypeSystemEventsCollection2,
  GetPermissionsParams,
  GetRolesParams,
  GetSystemEventsParams,
} from "./models";

/**
 * @summary Run System Action
 */
export const useRunSystemActionHook = () => {
  const runSystemAction = useOrvalAxiosInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return runSystemAction({
        url: `/api/v2/system/actions`,
        method: "GET",
        signal,
      });
    },
    [runSystemAction],
  );
};

export const getRunSystemActionQueryKey = () => {
  return [`/api/v2/system/actions`] as const;
};

export const useRunSystemActionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRunSystemActionQueryKey();

  const runSystemAction = useRunSystemActionHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>
  > = ({ signal }) => runSystemAction(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RunSystemActionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>
>;
export type RunSystemActionQueryError = ErrorType<ApitypeAppError2>;

export function useRunSystemAction<
  TData = Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunSystemAction<
  TData = Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useRunSystemAction<
  TData = Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Run System Action
 */

export function useRunSystemAction<
  TData = Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useRunSystemActionHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useRunSystemActionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Permissions
 */
export const useGetPermissionsHook = () => {
  const getPermissions = useOrvalAxiosInstance<ApitypePermissionsResponse>();

  return useCallback(
    (params: GetPermissionsParams, signal?: AbortSignal) => {
      return getPermissions({
        url: `/api/v2/system/authorization/permissions`,
        method: "GET",
        params,
        signal,
      });
    },
    [getPermissions],
  );
};

export const getGetPermissionsQueryKey = (params?: GetPermissionsParams) => {
  return [
    `/api/v2/system/authorization/permissions`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetPermissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPermissionsQueryKey(params);

  const getPermissions = useGetPermissionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>
  > = ({ signal }) => getPermissions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>
>;
export type GetPermissionsQueryError = ErrorType<ApitypeAppError2>;

export function useGetPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetPermissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Permissions
 */

export function useGetPermissions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPermissionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetPermissionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Roles
 */
export const useGetRolesHook = () => {
  const getRoles = useOrvalAxiosInstance<ApitypeRolesResponse>();

  return useCallback(
    (params: GetRolesParams, signal?: AbortSignal) => {
      return getRoles({
        url: `/api/v2/system/authorization/roles`,
        method: "GET",
        params,
        signal,
      });
    },
    [getRoles],
  );
};

export const getGetRolesQueryKey = (params?: GetRolesParams) => {
  return [
    `/api/v2/system/authorization/roles`,
    ...(params ? [params] : []),
  ] as const;
};

export const useGetRolesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRolesQueryKey(params);

  const getRoles = useGetRolesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
  > = ({ signal }) => getRoles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRolesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
>;
export type GetRolesQueryError = ErrorType<ApitypeAppError2>;

export function useGetRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetRolesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Roles
 */

export function useGetRoles<
  TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: GetRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetRolesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get System Events
 */
export const useGetSystemEventsHook = () => {
  const getSystemEvents =
    useOrvalAxiosInstance<ApitypeSystemEventsCollection2>();

  return useCallback(
    (params?: GetSystemEventsParams, signal?: AbortSignal) => {
      return getSystemEvents({
        url: `/api/v2/system/events`,
        method: "GET",
        params,
        signal,
      });
    },
    [getSystemEvents],
  );
};

export const getGetSystemEventsQueryKey = (params?: GetSystemEventsParams) => {
  return [`/api/v2/system/events`, ...(params ? [params] : [])] as const;
};

export const useGetSystemEventsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params?: GetSystemEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSystemEventsQueryKey(params);

  const getSystemEvents = useGetSystemEventsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>
  > = ({ signal }) => getSystemEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSystemEventsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>
>;
export type GetSystemEventsQueryError = ErrorType<ApitypeAppError2>;

export function useGetSystemEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params: undefined | GetSystemEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params?: GetSystemEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params?: GetSystemEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get System Events
 */

export function useGetSystemEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  params?: GetSystemEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSystemEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all the system events related to the resource.
 * @summary Get System Events by Resource
 */
export const useGetSystemEventsbyResourceHook = () => {
  const getSystemEventsbyResource =
    useOrvalAxiosInstance<ApitypeSystemEventsCollection2>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getSystemEventsbyResource({
        url: `/api/v2/system/events/resource/${id}`,
        method: "GET",
        signal,
      });
    },
    [getSystemEventsbyResource],
  );
};

export const getGetSystemEventsbyResourceQueryKey = (id?: string) => {
  return [`/api/v2/system/events/resource/${id}`] as const;
};

export const useGetSystemEventsbyResourceQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
  >,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSystemEventsbyResourceQueryKey(id);

  const getSystemEventsbyResource = useGetSystemEventsbyResourceHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>>
  > = ({ signal }) => getSystemEventsbyResource(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSystemEventsbyResourceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>>
>;
export type GetSystemEventsbyResourceQueryError = ErrorType<ApitypeAppError2>;

export function useGetSystemEventsbyResource<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
  >,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEventsbyResource<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
  >,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
          >,
          TError,
          Awaited<
            ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEventsbyResource<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
  >,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get System Events by Resource
 */

export function useGetSystemEventsbyResource<
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
  >,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<ReturnType<typeof useGetSystemEventsbyResourceHook>>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSystemEventsbyResourceQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get System Event
 */
export const useGetSystemEventHook = () => {
  const getSystemEvent = useOrvalAxiosInstance<ApitypeSystemEventResponse2>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return getSystemEvent({
        url: `/api/v2/system/events/${id}`,
        method: "GET",
        signal,
      });
    },
    [getSystemEvent],
  );
};

export const getGetSystemEventQueryKey = (id?: string) => {
  return [`/api/v2/system/events/${id}`] as const;
};

export const useGetSystemEventQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSystemEventQueryKey(id);

  const getSystemEvent = useGetSystemEventHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>
  > = ({ signal }) => getSystemEvent(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSystemEventQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>
>;
export type GetSystemEventQueryError = ErrorType<ApitypeAppError2>;

export function useGetSystemEvent<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEvent<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSystemEvent<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get System Event
 */

export function useGetSystemEvent<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
  TError = ErrorType<ApitypeAppError2>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetSystemEventHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSystemEventQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
